var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.33331C13.9706 6.33331 18 5.02748 18 3.41666C18 1.80583 13.9706 0.5 9 0.5C4.02944 0.5 0 1.80583 0 3.41666C0 5.02748 4.02944 6.33331 9 6.33331Z",
    fill: "#1E1A1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.33331C13.9706 6.33331 18 5.02748 18 3.41666C18 1.80583 13.9706 0.5 9 0.5C4.02944 0.5 0 1.80583 0 3.41666C0 5.02748 4.02944 6.33331 9 6.33331Z",
    fill: "#1E1A1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9332 7.13927C14.0546 7.74804 11.5924 8.08334 9 8.08334C6.40765 8.08334 3.94541 7.74804 2.06684 7.13927C1.20712 6.86067 0.530402 6.54403 0 6.20814V7.44165C0 8.22071 0.936106 8.95318 2.63605 9.50402C4.33589 10.0549 6.59598 10.3583 9 10.3583C11.404 10.3583 13.6641 10.055 15.3639 9.50406C17.0638 8.95318 18 8.22071 18 7.44165V6.20814C17.4696 6.54403 16.7929 6.8606 15.9332 7.13927Z",
    fill: "#1E1A1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9332 11.1643C14.0546 11.773 11.5924 12.1083 9 12.1083C6.40765 12.1083 3.94537 11.773 2.06684 11.1642C1.20709 10.8856 0.530367 10.5691 0 10.2332V11.5834C0 13.1942 4.02943 14.5 9 14.5C13.9706 14.5 18 13.1942 18 11.5833V10.2332C17.4697 10.569 16.7929 10.8857 15.9332 11.1643Z",
    fill: "#1E1A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/details.d64455c4d098b7710bfff1481598122e.svg";
export { ForwardRef as ReactComponent };